export function getQualifiedClassName(instance: any): string {
    if (instance && instance.constructor) {
        if (instance.constructor.name === "Function") {
            if (instance.__fname) {
                return instance.__fname;
            }
            let className = instance.toString();
            className = className.substring(9, className.indexOf("("));
            return className;
        }
        return instance.constructor.__fname || instance.constructor.name;
    }
    return instance + "";
}
